// extracted by css-extract-rspack-plugin
export default {"content":"BeX41","dragContainer":"VNJtv","dragHandle":"Io3AF","wrapper":"UMyCl"};